import { gql } from 'apollo-boost';
const removeSegment = gql `
	mutation ($seg_id: String!) {
		deleteSegment(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const removeMixedSegment = gql `
	mutation ($seg_id: String!) {
		deleteMixedSegment(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const removeSegmentFromPlatform = gql `
	mutation ($seg_id: String!) {
		deleteSegmentFromPlatform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const importSegmentToPlatform = gql `
	mutation ($seg_id: String!) {
		importSegmentToPlatform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const removeMixedSegmentFromPlatform = gql `
	mutation ($seg_id: String!) {
		deleteMixedSegmentFromPlatform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const importMixedSegmentToPlatform = gql `
	mutation ($seg_id: String!) {
		importMixedSegmentToPlatform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const getMixSegmentsQuery = gql `
	{
		getMixSegments {
			id
			name
			combined
			firstRun
			sendToPlatform
			platformLabel
			externalId
		}
	}
`;
const getSegmentsQuery = gql `
	{
		segments {
			id
			name
			interests
			operator
			certainty
			sendToPlatform
			defaultInterests
			certaintyDefaultInterests
			income
			certaintyIncome
			education
			educationCertainty
			abcde
			abcdeCertainty
			firstRun
			lookalikeId
			lookalikeCertainty
			interestOperator
			socDemo {
				id
				name
				certainty
				ageGroups
				isAgeGroup18Plus
				isAgeGroup18Minus
				gender
			}
			platformLabel
			targetId
			targetName
			lookalikeName
			externalId
		}
	}
`;
const getSegmentationQueueQuery = gql `
	{
		segmentationQueue {
			platformUploadCompletedAt
			id
			clientId
			segmentId
			segmentName
		}
}
`;
const getSegmentsDashboardQuery = gql `
	{
		segmentsDashboard {
			id
  			name
  			platformUploadCompletedAt
		}
	}
`;
const getLastSegmentQuery = gql `
	{
		lsegment {
			segmentIntId
		}
	}
`;
const copySegment = gql `
	mutation ($id: String!, $name: String!) {
		duplicateSegment(id: $id, name: $name) {
			ok
			copiedSegment {
				id
				name
			}
		}
	}
`;
const GET_COOKIES_QUERY = gql `
	query (
		$confidence: Float
		$socDemoConfidence: Float
		$ageGroups: [String]
		$interestOne: Int!
		$interestTwo: Int
		$newInterest: [String]
		$newConfidence: Float
		$interestsOperator: InterestsOperatorEnum
		$gender: GenderEnum
		$income: [String]
		$incomeConf: Float
		$education: [String]
		$educationConf: Float
		$abcde: [String]
		$abcdeConf: Float
		$isLookalike: Boolean
		$lookalikeConf: Float
		$basicInterestOperator: InterestsOperatorEnum
	) {
		cookieCount(
			confidence: $confidence
			socDemoConfidence: $socDemoConfidence
			ageGroups: $ageGroups
			interest: $interestOne
			interest2: $interestTwo
			newInterests: $newInterest
			newConfidence: $newConfidence
			interestsOperator: $interestsOperator
			gender: $gender
			income: $income
			incomeConf: $incomeConf
			education: $education
			abcde: $abcde
			educationConf: $educationConf
			abcdeConf: $abcdeConf
			isLookalike: $isLookalike
			lookalikeConf: $lookalikeConf
			basicInterestOperator: $basicInterestOperator
		)
	}
`;
const GET_MIX_COOKIES_QUERY = gql `
	query ($queryBuild: [String]) {
		mixCookieCount(queryBuild: $queryBuild)
	}
`;
const createMixedSegment = gql `
	mutation (
		$name: String!
		$combined: JSONString!
		$sendToPlatform: Boolean!
		$fee: Decimal!
		$external_id: String
	) {
		createMixedSegment(
			input: {
				name: $name
				combined: $combined
				fee: $fee
				sendToPlatform: $sendToPlatform
				externalId: $external_id
			}
		) {
			ok
			segment {
				id
				name
			}
		}
	}
`;
const getTargetsQuery = gql `
	{
		trackings {
			id
			tpName
			tpId
		}
	}
`;
const createSegmentsQuery = gql `
	mutation (
		$name: String!
		$certainty: Float!
		$sendToPlatform: Boolean!
		$fee: Decimal!
		$interests: JSONString!
		$operator: String
		$gender: String
		$ageGroups: JSONString!
		$is_age_group_18_plus: Boolean!
		$is_age_group_18_minus: Boolean!
		$socDemoConfidence: Float!
		$income: JSONString!
		$certainty_income: Float!
		$education: JSONString!
		$education_certainty: Float!
		$abcde: JSONString!
		$abcde_certainty: Float!
		$default_interests: JSONString!
		$certainty_default_interests: Float!
		$target_id: String
		$lookalike_id: String
		$lookalike_certainty: Float!
		$interest_operator: String!
		$external_id: String
	) {
		createSegment(
			input: {
				name: $name
				certainty: $certainty
				sendToPlatform: $sendToPlatform
				fee: $fee
				interests: $interests
				operator: $operator
				gender: $gender
				ageGroups: $ageGroups
				isAgeGroup18Plus: $is_age_group_18_plus
				isAgeGroup18Minus: $is_age_group_18_minus
				socioCertainty: $socDemoConfidence
				income: $income
				education: $education
				abcde: $abcde
				certaintyIncome: $certainty_income
				educationCertainty: $education_certainty
				abcdeCertainty: $abcde_certainty
				defaultInterests: $default_interests
				certaintyDefaultInterests: $certainty_default_interests
				targetId: $target_id
				lookalikeId: $lookalike_id
				lookalikeCertainty: $lookalike_certainty
				interestOperator: $interest_operator
				externalId: $external_id
			}
		) {
			ok
			message
			segment {
				id
				name
			}
		}
	}
`;
const GPT_QUERY = gql `
	query (
		$previousQuery: String
		$userQuery: String
	) {
		gptResult(
			previousQuery: $previousQuery
			userQuery: $userQuery
		) {
			status
			query
			explanation
			count
			errorText
		}
	}
`;
export { removeSegment, removeMixedSegment, removeMixedSegmentFromPlatform, importMixedSegmentToPlatform, removeSegmentFromPlatform, importSegmentToPlatform, getSegmentsQuery, getSegmentationQueueQuery, getMixSegmentsQuery, copySegment, GET_COOKIES_QUERY, GET_MIX_COOKIES_QUERY, createMixedSegment, getTargetsQuery, createSegmentsQuery, getLastSegmentQuery, getSegmentsDashboardQuery, GPT_QUERY };
